import React, { useState } from 'react';
import Popup from 'reactjs-popup';
 
const ConfirmationModalDeleteUpload = ({ isOpen, onClose, onSave, onCancel, nbUploads }) => {
    const handleSave = () => {
        onSave();  
    };

    const handleCancel = () => {
        onCancel();  
    };
 
    return (
        <Popup
            open={isOpen}
            onClose={onClose}
            contentStyle={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: '20px',
                border: '1px solid #d9d7d7',
                borderRadius: '5px',
                backgroundColor: '#fff',
                boxSizing: 'border-box',
            }}
            overlayStyle={{
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                zIndex: 1040,
            }}
        >
            <div className="modal-content" style={{ color: 'darkblue' }}>
                <h5 className='popupTitle'>Please confirm the deletion of {nbUploads} file{nbUploads>1 ? "s" : ""}.</h5>
                <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button className="btn btn-cancel" onClick={handleCancel}>CANCEL</button>
                    <button className="btn btn-save" onClick={handleSave}>CONFIRM</button>
                </div>
            </div>
        </Popup>
    );
};
 
export default ConfirmationModalDeleteUpload;